import { callService } from '@api/caller';
import { BasketViewModel, EmptyResponseViewModel } from '@api/index';

/**
 * @description Clear basket items. If onlyVehicle is true, only vehicle item will be removed.
 * @param basketInfo BasketViewModel
 * @param basketId string
 * @param onlyVehicle boolean
 * @returns Promise<void>
 */
export const clearBasket = async (
  basketInfo: BasketViewModel,
  basketId: string
) => {
  const itemsPromisees: EmptyResponseViewModel[] = [];

  // flight items
  for (let i = 0; i < basketInfo?.flights?.length; i++) {
    itemsPromisees.push(
      await callService('BasketsService', 'remove', {
        basketId,
        itemId: basketInfo.flights[i].itemId,
      })
    );
  }

  // hotel items
  for (let i = 0; i < basketInfo?.hotels?.length; i++) {
    itemsPromisees.push(
      await callService('BasketsService', 'remove', {
        basketId,
        itemId: basketInfo.hotels[i]?.itemId as string,
      })
    );
  }

  // tour items
  for (let i = 0; i < basketInfo?.tours?.length; i++) {
    itemsPromisees.push(
      await callService('BasketsService', 'remove', {
        basketId,
        itemId: basketInfo.tours[i]?.itemId as string,
      })
    );
  }

  // vehicle item
  if (basketInfo?.vehicle) {
    itemsPromisees.push(
      await callService('BasketsService', 'remove', {
        basketId,
        itemId: basketInfo?.vehicle?.itemId as string,
      })
    );
  }

  await Promise.all(itemsPromisees);
};
